export const MAX_PROFILE_FIELDS = 30;
const MAX_FIELD_KEY_LENGTH = 50;
const RESPONSE_PATH_PATTERN = /^[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+){0,11}$/;

export const uniqueFieldKey = (path, usedKeys) => {
  const normalized = path
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  const base = (
    /^[a-z]/.test(normalized) ? normalized : `field_${normalized}`
  ).slice(0, MAX_FIELD_KEY_LENGTH);
  let key = base;
  let index = 2;
  while (usedKeys.has(key)) {
    const suffix = `_${index}`;
    key = `${base.slice(0, MAX_FIELD_KEY_LENGTH - suffix.length)}${suffix}`;
    index += 1;
  }
  return key;
};

const readPath = (body, path) =>
  path ? path.split('.').reduce((value, key) => value?.[key], body) : body;

const inferType = value => {
  if (typeof value === 'boolean') return 'boolean';
  if (typeof value === 'number') return 'number';
  if (
    typeof value === 'string' &&
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value) &&
    !Number.isNaN(Date.parse(value))
  ) {
    return 'datetime';
  }
  return 'text';
};

export const mergeResponseFields = (fields, paths, body, responseRoot) => {
  const result = [...fields];
  const usedPaths = new Set(fields.map(field => field.path));
  const usedKeys = new Set(fields.map(field => field.key));
  const root = readPath(body, responseRoot);

  paths.forEach(path => {
    if (
      result.length >= MAX_PROFILE_FIELDS ||
      usedPaths.has(path) ||
      path.length > 200 ||
      !RESPONSE_PATH_PATTERN.test(path)
    ) {
      return;
    }
    const key = uniqueFieldKey(path, usedKeys);
    result.push({
      key,
      label: path.slice(0, 80),
      path,
      type: inferType(readPath(root, path)),
      group: '',
      visible: true,
      currency: 'CNY',
      status_map_text: '{}',
    });
    usedKeys.add(key);
    usedPaths.add(path);
  });
  return result;
};
